/* eslint-disable */
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTrash,
  faChevronDown,
  faChevronUp,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";

const AddProductModal = ({ isOpen, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [showContactSection, setShowContactSection] = useState(false);

  // Master product info
  const [productName, setProductName] = useState("");
  const [type, setType] = useState("subscription");
  const [notes, setNotes] = useState("");

  // First Renewal Cycle Fields
  const todayStr = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(todayStr);
  const [endDate, setEndDate] = useState("");
  const [reminderDays, setReminderDays] = useState(15);
  const [totalCredits, setTotalCredits] = useState("");
  const [lowBalanceAlertAt, setLowBalanceAlertAt] = useState("");
  const [amountPaid, setAmountPaid] = useState("");
  const [renewalNotes, setRenewalNotes] = useState("");

  // Company info (optional accordion at last)
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [website, setWebsite] = useState("");
  const [supportUrl, setSupportUrl] = useState("");

  // Initial Contact Person
  const [initName, setInitName] = useState("");
  const [initDesignation, setInitDesignation] = useState("");
  const [initEmails, setInitEmails] = useState([""]);
  const [initPhones, setInitPhones] = useState([""]);

  // Support Contact Person
  const [suppName, setSuppName] = useState("");
  const [suppDesignation, setSuppDesignation] = useState("");
  const [suppEmails, setSuppEmails] = useState([""]);
  const [suppPhones, setSuppPhones] = useState([""]);

  if (!isOpen) return null;

  const handleArrayChange = (setter, list, index, value) => {
    const updated = [...list];
    updated[index] = value;
    setter(updated);
  };

  const handleAddArrayItem = (setter, list) => {
    setter([...list, ""]);
  };

  const handleRemoveArrayItem = (setter, list, index) => {
    if (list.length <= 1) {
      setter([""]);
    } else {
      setter(list.filter((_, i) => i !== index));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!productName.trim()) {
      showToast.error("Product name is required");
      return;
    }
    if (!startDate) {
      showToast.error("Start date is required");
      return;
    }
    if (type === "subscription" && !endDate) {
      showToast.error("End date is required for subscription products");
      return;
    }
    if (type === "credits" && (!totalCredits || Number(totalCredits) <= 0)) {
      showToast.error("Total credits is required for credits products");
      return;
    }
    if (amountPaid === "" || Number(amountPaid) < 0) {
      showToast.error("Amount paid is required");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const cleanedInitEmails = initEmails.map((e) => e.trim()).filter(Boolean);
      const cleanedInitPhones = initPhones.map((p) => p.trim()).filter(Boolean);
      const cleanedSuppEmails = suppEmails.map((e) => e.trim()).filter(Boolean);
      const cleanedSuppPhones = suppPhones.map((p) => p.trim()).filter(Boolean);

      const contactDetails = {
        company_info: {
          company_name: companyName.trim(),
          address: address.trim(),
          gst_number: gstNumber.trim(),
        },
        contact_info: {
          website: website.trim(),
          support_url: supportUrl.trim(),
        },
        initial_contact_person: {
          name: initName.trim(),
          designation: initDesignation.trim(),
          emails: cleanedInitEmails,
          phones: cleanedInitPhones,
        },
        support_contact_person: {
          name: suppName.trim(),
          designation: suppDesignation.trim(),
          emails: cleanedSuppEmails,
          phones: cleanedSuppPhones,
        },
      };

      const payload = {
        product_name: productName.trim(),
        type,
        notes: notes.trim() || undefined,
        contact_details: contactDetails,
        start_date: startDate,
        amount_paid: Number(amountPaid),
        renewal_notes: renewalNotes.trim() || undefined,
      };

      if (type === "subscription") {
        payload.end_date = endDate;
        payload.reminder_before_days = Number(reminderDays) || 15;
      } else {
        payload.total_credits = Number(totalCredits);
        payload.credits_remaining = Number(totalCredits);
        payload.low_balance_alert_at = lowBalanceAlertAt ? Number(lowBalanceAlertAt) : 0;
      }

      const response = await axios.post(
        `${API_URL}settings/product-subscriptions`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.success) {
        showToast.success("Product created successfully!");
        onSuccess();
        onClose();
      }
    } catch (err) {
      console.error("Error creating product:", err);
      const msg = err.response?.data?.message || err.message || "Failed to create product";
      showToast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050, overflowY: "auto" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        style={{ maxWidth: "800px", margin: "1.75rem auto" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="modal-content with-shadow"
          style={{
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            borderRadius: "4px",
            background: "#fff",
          }}
        >
          {/* Header */}
          <div
            className="modal-header d-flex justify-content-between align-items-center"
            style={{
              padding: "12px 20px",
              borderBottom: "1px solid #eee",
              background: "#f8f9fa",
            }}
          >
            <h5 className="modal-title fw-bold m-0" style={{ fontSize: "1rem", color: "#242a30" }}>
              Add Product / Service
            </h5>
            <button
              type="button"
              className="btn btn-default btn-xs"
              onClick={onClose}
              style={{ padding: "2px 8px" }}
              title="Close"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              flex: "1 1 auto",
              overflow: "hidden",
            }}
          >
            {/* Scrollable Body */}
            <div
              className="modal-body"
              style={{
                overflowY: "auto",
                maxHeight: "calc(90vh - 120px)",
                padding: "20px",
              }}
            >
              {/* 1. Product Basic Details */}
              <h6 className="fw-bold text-primary mb-3" style={{ fontSize: "0.9rem" }}>
                Product Details
              </h6>
              <div className="row g-2 mb-4">
                <div className="col-md-8">
                  <label className="form-label fw-bold small">
                    Product Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="e.g. Aisensy WhatsApp Platform, GoDaddy Domain"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-bold small">
                    Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control form-control-sm"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <option value="subscription">Subscription (Time-based)</option>
                    <option value="credits">Credits (Usage-based)</option>
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label fw-bold small">Notes (Optional)</label>
                  <textarea
                    className="form-control form-control-sm"
                    rows="2"
                    placeholder="General remarks or notes about product..."
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                </div>
              </div>

              {/* 2. Initial Renewal Cycle (Renewal #1) */}
              <h6 className="fw-bold text-primary mb-3" style={{ fontSize: "0.9rem" }}>
                Initial Cycle Details (Cycle #1)
              </h6>
              <div className="row g-2 mb-4">
                <div className="col-md-4">
                  <label className="form-label fw-bold small">
                    Start Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    required
                  />
                </div>

                {type === "subscription" ? (
                  <>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small">
                        Expiry Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small">Alert Before (Days)</label>
                      <input
                        type="number"
                        min="1"
                        className="form-control form-control-sm"
                        value={reminderDays}
                        onChange={(e) => setReminderDays(e.target.value)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small">
                        Total Credits Added <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        step="any"
                        className="form-control form-control-sm"
                        value={totalCredits}
                        onChange={(e) => setTotalCredits(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small">Low Balance Alert At</label>
                      <input
                        type="number"
                        step="any"
                        className="form-control form-control-sm"
                        value={lowBalanceAlertAt}
                        onChange={(e) => setLowBalanceAlertAt(e.target.value)}
                      />
                    </div>
                  </>
                )}

                <div className="col-md-6">
                  <label className="form-label fw-bold small">
                    Amount Paid (₹) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control form-control-sm"
                    placeholder="0.00"
                    value={amountPaid}
                    onChange={(e) => setAmountPaid(e.target.value)}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-bold small">Cycle Notes</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Initial cycle remark..."
                    value={renewalNotes}
                    onChange={(e) => setRenewalNotes(e.target.value)}
                  />
                </div>
              </div>

              {/* 3. Company & Contact Details (Optional) - ACCORDION AT THE LAST */}
              <div className="mb-2">
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    cursor: "pointer",
                    background: "#f8f9fa",
                    padding: "10px 15px",
                    border: "1px solid #ddd",
                    borderRadius: showContactSection ? "4px 4px 0 0" : "4px",
                  }}
                  onClick={() => setShowContactSection(!showContactSection)}
                >
                  <span className="fw-bold" style={{ fontSize: "0.85rem", color: "#242a30" }}>
                    Company & Contact Details (Optional)
                  </span>
                  <FontAwesomeIcon icon={showContactSection ? faChevronUp : faChevronDown} />
                </div>

                {showContactSection && (
                  <div
                    style={{
                      padding: "15px",
                      border: "1px solid #ddd",
                      borderTop: "none",
                      background: "#fff",
                      borderRadius: "0 0 4px 4px",
                    }}
                  >
                    {/* Company Information */}
                    <h6 className="fw-bold text-primary mb-2" style={{ fontSize: "0.85rem" }}>
                      Company Information
                    </h6>
                    <div className="row g-2 mb-3">
                      <div className="col-md-4">
                        <label className="form-label fw-bold small">Company Name</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Company name"
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold small">GST Number</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="GST number"
                          value={gstNumber}
                          onChange={(e) => setGstNumber(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold small">Website</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="https://example.com"
                          value={website}
                          onChange={(e) => setWebsite(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Address</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Company office address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Support URL</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="https://support.example.com"
                          value={supportUrl}
                          onChange={(e) => setSupportUrl(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* Initial Contact Person */}
                    <h6 className="fw-bold text-primary mb-2 pt-2 border-top" style={{ fontSize: "0.85rem" }}>
                      Initial Contact Person
                    </h6>
                    <div className="row g-2 mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Name</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Contact person name"
                          value={initName}
                          onChange={(e) => setInitName(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Designation</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="e.g. Account Manager, Sales Rep"
                          value={initDesignation}
                          onChange={(e) => setInitDesignation(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Emails</label>
                        {initEmails.map((email, idx) => (
                          <div key={idx} className="input-group input-group-sm mb-1">
                            <input
                              type="email"
                              className="form-control form-control-sm"
                              placeholder="email@example.com"
                              value={email}
                              onChange={(e) =>
                                handleArrayChange(setInitEmails, initEmails, idx, e.target.value)
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-default btn-xs text-danger"
                              onClick={() =>
                                handleRemoveArrayItem(setInitEmails, initEmails, idx)
                              }
                              title="Remove email"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-default btn-xs mt-1"
                          onClick={() => handleAddArrayItem(setInitEmails, initEmails)}
                        >
                          <FontAwesomeIcon icon={faPlus} className="me-1" /> Add Email
                        </button>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Phones</label>
                        {initPhones.map((phone, idx) => (
                          <div key={idx} className="input-group input-group-sm mb-1">
                            <input
                              type="tel"
                              className="form-control form-control-sm"
                              placeholder="+91 9876543210"
                              value={phone}
                              onChange={(e) =>
                                handleArrayChange(setInitPhones, initPhones, idx, e.target.value)
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-default btn-xs text-danger"
                              onClick={() =>
                                handleRemoveArrayItem(setInitPhones, initPhones, idx)
                              }
                              title="Remove phone"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-default btn-xs mt-1"
                          onClick={() => handleAddArrayItem(setInitPhones, initPhones)}
                        >
                          <FontAwesomeIcon icon={faPlus} className="me-1" /> Add Phone
                        </button>
                      </div>
                    </div>

                    {/* Support Contact Person */}
                    <h6 className="fw-bold text-primary mb-2 pt-2 border-top" style={{ fontSize: "0.85rem" }}>
                      Support Contact Person
                    </h6>
                    <div className="row g-2">
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Name</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Support contact name"
                          value={suppName}
                          onChange={(e) => setSuppName(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Designation</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="e.g. Technical Support Engineer"
                          value={suppDesignation}
                          onChange={(e) => setSuppDesignation(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Emails</label>
                        {suppEmails.map((email, idx) => (
                          <div key={idx} className="input-group input-group-sm mb-1">
                            <input
                              type="email"
                              className="form-control form-control-sm"
                              placeholder="support@example.com"
                              value={email}
                              onChange={(e) =>
                                handleArrayChange(setSuppEmails, suppEmails, idx, e.target.value)
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-default btn-xs text-danger"
                              onClick={() =>
                                handleRemoveArrayItem(setSuppEmails, suppEmails, idx)
                              }
                              title="Remove email"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-default btn-xs mt-1"
                          onClick={() => handleAddArrayItem(setSuppEmails, suppEmails)}
                        >
                          <FontAwesomeIcon icon={faPlus} className="me-1" /> Add Email
                        </button>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold small">Phones</label>
                        {suppPhones.map((phone, idx) => (
                          <div key={idx} className="input-group input-group-sm mb-1">
                            <input
                              type="tel"
                              className="form-control form-control-sm"
                              placeholder="+91 9876543210"
                              value={phone}
                              onChange={(e) =>
                                handleArrayChange(setSuppPhones, suppPhones, idx, e.target.value)
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-default btn-xs text-danger"
                              onClick={() =>
                                handleRemoveArrayItem(setSuppPhones, suppPhones, idx)
                              }
                              title="Remove phone"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-default btn-xs mt-1"
                          onClick={() => handleAddArrayItem(setSuppPhones, suppPhones)}
                        >
                          <FontAwesomeIcon icon={faPlus} className="me-1" /> Add Phone
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Footer */}
            <div
              className="modal-footer"
              style={{
                borderTop: "1px solid #dee2e6",
                background: "#f8f9fa",
                padding: "10px 20px",
              }}
            >
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={onClose}
                disabled={loading}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-sm"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Product"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <style>{`
        .btn-default {
          background: #f8f9fa;
          border: 1px solid #ddd;
        }
        .btn-xs {
          padding: 2px 6px;
          font-size: 12px;
          line-height: 1.5;
        }
        .form-label {
          margin-bottom: 3px;
        }
      `}</style>
    </div>
  );
};

export default AddProductModal;
